// extracted by mini-css-extract-plugin
module.exports = {"orderInformation":"Vx","paymentUpdateSuccess":"Wx","orderNumber":"Xx"};